export const countersReducer = (state = {loading:true,result:null,counters:null,counter:null} , action) => {
    switch (action.type) {
        case 'COUNTER_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'COUNTERS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                counters: action.payload
            }
        case 'COUNTERS_GET_BY_FARM_SUCCESS':
            return {
                ...state,
                loading:false,
                counters: action.payload
            }
        case 'COUNTER_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                counter: action.payload
            }
        case 'COUNTER_EDIT_SUCCESS':
            return {
                ...state,
                loading: false,
                counter: action.payload
            }
        case 'COUNTER_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                counters: state.counters.filter(counter => counter._id !== action.payload.idCounter)
            }
        case 'COUNTER_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'COUNTER_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'COUNTER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'COUNTER_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

